// extracted by mini-css-extract-plugin
export default {"option":"LookupEditorControl_option__LpcfJ"};